// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__1SWDE","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__2L_bG"};